module.exports = __webpack_public_path__ + "img/LeanLarder.305ee469.png";